/// <amd-module name="Test/TestPlansLibrary/Pivots/TestCasesPivot/Redux/TestCasesSelector" />
import { getAllColumnOptionsValues } from "Test/TestPlansLibrary/ColumnOptions/TestCasesColumnOptionUtils";
import * as Resources from "Test/TestPlansLibrary/Pivots/TestCasesPivot/Resources";
import { ITestCasesAwareState, ITestCaseItem } from "./TestCasesContracts";
import { IUserIdentity, ILibraryWorkItemDataProviderState } from "Test/TestPlansLibrary/LibraryHub/Redux/TestPlansLibraryContracts";
import { WorkItemDetails } from "TestPlanCommon/Contracts/TestPlan";
import { WorkItemConstants } from "Test/TestPlansLibrary/LibraryHub/Constants";

export const getTestCasesFromState = (state: ITestCasesAwareState): WorkItemDetails[] => {
    return state.testCasesState.testCases;
};

export const getTestCaseItemsFromState = (state: ITestCasesAwareState): ITestCaseItem[] | undefined => {
    if (state.testCasesState && state.testCasesState.testCases) {
        const testCases: WorkItemDetails[] = getTestCasesFromState(state);
        return getTestCaseItemsFromTestCase(testCases);
    }

    return undefined;
};

export const getWorkItemDataProviderStateFromState = (state: ITestCasesAwareState): ILibraryWorkItemDataProviderState | undefined => {
    if (state.testCasesState && state.testCasesState.workItemDataProviderState) {
        return state.testCasesState.workItemDataProviderState;
    }

    return undefined;
};

export const getIsLoadingFromState = (state: ITestCasesAwareState): boolean => {
    if (state.testCasesState && state.testCasesState.isLoading !== undefined) {
        return state.testCasesState.isLoading;
    }

    return true;
};

export function getTestCaseItemsFromTestCase(testCases: WorkItemDetails[]): ITestCaseItem[] {
    const testCasesForView: ITestCaseItem[] = [];

    if (testCases) {
        for (let i = 0; i < testCases.length; i++) {
            testCasesForView.push({
                id: testCases[i].id,
                title: testCases[i].name,
                assignedTo: _getAssignedTo(testCases[i]),
                state: _getTestCaseWorkItemField(testCases[i], WorkItemConstants.WitStateField),
                areaPath: _getTestCaseWorkItemField(testCases[i], WorkItemConstants.WitAreaPathField),
                tags: _getTestCaseWorkItemField(testCases[i], WorkItemConstants.WitTagsField)
            });
            testCasesForView[i].columnOptionValues = getAllColumnOptionsValues(testCases[i]);
        }
    }
    return testCasesForView;
}

function _getTestCaseWorkItemField(testCase: WorkItemDetails, fieldName: string): string {
    let field = "";

    if (testCase && testCase.workItemFields) {
        const workItemAssignedToField = testCase.workItemFields.find(item => item.hasOwnProperty(fieldName));
        if (workItemAssignedToField) {
            field = workItemAssignedToField[fieldName];
        }
    }

    return field;
}

function _getAssignedTo(testCase: WorkItemDetails): IUserIdentity {
    const userIdentity: IUserIdentity = {
        id: "00000000-0000-0000-0000-000000000000",
        displayName: Resources.Unassigned
    };

    if (testCase && testCase.workItemFields) {
        const workItemAssignedToField = testCase.workItemFields.find(item => item.hasOwnProperty(WorkItemConstants.WitAssignedToField));
        if (workItemAssignedToField) {
            const workItemIdentity = workItemAssignedToField[WorkItemConstants.WitAssignedToField];

            if (workItemIdentity && workItemIdentity.identityRef) {
                userIdentity.id = workItemIdentity.identityRef.id;

                userIdentity.displayName = workItemIdentity.identityRef.displayName
                    ? workItemIdentity.identityRef.displayName
                    : workItemIdentity.identityRef.uniqueName;
            }
        }
    }

    return userIdentity;
}

export const getColumnOptionFields = (state: ITestCasesAwareState): string[] | undefined => {
    if (state.testCasesState && state.testCasesState.workItemDataProviderState) {
        return state.testCasesState.workItemDataProviderState.columnOptions;
    }

    return undefined;
};
